import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-diagnosis-tri-dialog',
  templateUrl: './diagnosis-tri-dialog.component.html',
  styleUrls: ['./diagnosis-tri-dialog.component.scss']
})
export class DiagnosisTriDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<DiagnosisTriDialogComponent>) { }

  ngOnInit(): void {
  }

  onOkClick() {
    this.dialogRef.close();
  }
}
